class modalSumCtrl {
    constructor($scope, $uibModalInstance, httpRequest, items1,globalFn) {
        $scope.companyProperty=localStorage.user_info&&JSON.parse(localStorage.user_info).sale.companyProperty
        function fixNumber(v){
            if(v===null||v===''||v===undefined)return ''
            return v.toFixed(2)
        }
        httpRequest.get_ivatAuthStatisticsCheckDetail(items1).then((res) => {
            if (res.data.success) {
                let result=res.data.value
                result.forEach(item=>{
                    item.bdkje=fixNumber(item.bdkje)
                    item.bdkse=fixNumber(item.bdkse)
                    item.dkje=fixNumber(item.dkje)
                    item.dkse=fixNumber(item.dkse)
                    item.tsje=fixNumber(item.tsje)
                    item.tsse=fixNumber(item.tsse)
                })
                $scope.modalSumList = result
            }
        })
        $scope.cancel = () => {
            // $uibModalInstance.dismiss();
            $uibModalInstance.close()
        }
        $scope.exportSum = () => {
            items1.accessToken=localStorage.id_token
            httpRequest.get_exportExportCheckDetail(items1)
        }
    }
}

modalSumCtrl.$inject = ['$scope', '$uibModalInstance', 'httpRequest', 'items1','globalFn']
export default modalSumCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/inputStatistics/identificationSummarize/modalSumCtrl.js